import * as React from 'react';
import * as R from 'ramda';
import ConfigView from './ConfigView';
import { ResortToolsConfig } from './config/resortToolsConfig';
import { Navigate } from 'react-router-dom';


/**
 * ConfigRedirect: a component that
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default ConfigView(class ConfigRedirect extends React.PureComponent<{
  configPath: string | string[];
  redirectRoute: string;
  config?: ResortToolsConfig;
  userRole?: string | undefined;
  children?: React.ReactNode;
}> {
  public render = () => {
    const path    = ([] as string[]).concat(this.props.configPath);
    const value   = R.path(path, this.props.config);
    const role    = this.props.userRole;
    const isArray = Array.isArray(value);

    return (isArray && R.includes(role, value as [])) || (!isArray && !!value)
           ? this.props.children
           : <Navigate to={this.props.redirectRoute} replace/>;
  };
});

